import { useState, useEffect } from "react";
import Button from "../../../components/base/Button";
import heroImage from "../../../assets/hero-novo.JPG"; // ✅ sua imagem local

export default function HeroSection() {
	const scrollToSection = (sectionId: string) => {
		const element = document.getElementById(sectionId);
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<section
			id="inicio"
			className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
			style={{
				backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${heroImage})`,
				backgroundPosition: "center",
				backgroundSize: "cover",
				backgroundRepeat: "no-repeat",
			}}
		>
			<div className="container mx-auto px-4">
				{/* PRIMEIRA SEÇÃO — ocupa 100vh */}
				<div className="min-h-[75vh] mt-20 flex flex-col justify-center items-center text-center text-white">
					<div className="max-w-4xl mx-auto">
						<h1
							className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight"
							style={{ fontFamily: "DM Sans, sans-serif" }}
						>
							<span className="text-transparent bg-clip-text bg-gradient-to-r from-slate-200 to-blue-200 block">
								Contabilidade de Empresas
							</span>
							<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-200 to-green-200 block">
								sem Complicações
							</span>
						</h1>

						<p className="text-lg sm:text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed max-w-3xl mx-auto">
							Desde 1963 ajudando empresas a crescer com clareza,
							segurança e atendimento humano.
						</p>

						<div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
							<Button
								onClick={() => scrollToSection("contato")}
								className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold text-base sm:text-lg transition-all duration-300 transform hover:scale-105 shadow-xl"
							>
								<i className="ri-building-line mr-2"></i>
								Abra sua Empresa
							</Button>

							<a
								href="https://wa.me/551146381343"
								target="_blank"
								rel="noopener noreferrer"
								className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-semibold text-base sm:text-lg transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
							>
								<i className="ri-whatsapp-line mr-2"></i>
								Fale no WhatsApp
							</a>
						</div>
					</div>
				</div>

				{/* SEGUNDA SEÇÃO — fica logo abaixo */}
				<div className="py-10">
					<div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto text-center">
						<div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
							<div className="w-16 h-16 md:w-12 md:h-12 bg-blue-500 rounded-lg flex items-center justify-center mx-auto mb-4">
								<i className="ri-time-line text-white text-3xl"></i>
							</div>
							<h3 className="text-2xl font-semibold mb-2 text-white">
								Abertura Rápida
							</h3>
							<p className="text-gray-200 text-lg">
								Empresa aberta de 2 até 10 dias úteis
							</p>
						</div>

						<div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
							<div className="w-16 h-16 md:w-12 md:h-12 bg-green-500 rounded-lg flex items-center justify-center mx-auto mb-4">
								<i className="ri-shield-check-line text-white text-3xl"></i>
							</div>
							<h3 className="text-2xl font-semibold mb-2 text-white">
								60+ Anos
							</h3>
							<p className="text-gray-200 text-lg">
								De tradição e confiança
							</p>
						</div>

						<div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
							<div className="w-16 h-16 md:w-12 md:h-12 bg-purple-500 rounded-lg flex items-center justify-center mx-auto mb-4">
								<i className="ri-customer-service-2-line text-white text-3xl"></i>
							</div>
							<h3 className="text-2xl font-semibold mb-2 text-white">
								Atendimento
							</h3>
							<p className="text-gray-200 text-lg">
								100% humanizado
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
